import { LogoContainer, LogoIcon as StyledLogoIcon, LogoText as StyledLogoText } from './style';

interface LogoProps {
  size?: 'small' | 'medium' | 'large';
  showText?: boolean;
  color?: 'white' | 'green' | 'dark';
}

const logoSizes: Record<NonNullable<LogoProps['size']>, string> = {
  small: '34px',
  medium: '38px',
  large: '48px',
};

export function Logo({ size = 'medium', showText = true, color = 'green' }: LogoProps) {
  return (
    <LogoContainer>
      <StyledLogoIcon
        src="/favicon/web-app-manifest-192x192.png"
        alt={showText ? '' : 'MECBOV'}
        aria-hidden={showText}
        $size={logoSizes[size]}
      />
      {showText && <StyledLogoText $color={color}>MECBOV</StyledLogoText>}
    </LogoContainer>
  );
}
